define("shared/components/shared/post/secondary/hashtag-suggestions/paid-upgrade-modal", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/template-only",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <section class="o--modalBody--secondary u--p__0 has--footer">
    {{! Upgrade }}
    <div class="cMH--blank">
      <Shared::Post::Secondary::HashtagSuggestions::UpgradeModalBackground/>
      <div class="cMH--blank__overlay is--centered">
        <div class="u--p">
          <p class="u--text--bold u--text--md u--text--center u--m__b__xs">
            {{@upgradeTitle}}
          </p>
          <p class="u--text--light u--text--center u--m__b__0">
            {{@upgradeDescription}}
            <Shared::Link
              title={{t "hashtag_suggestions.upsell.title"}}
              @href={{@href}}
              @text={{t "shared_phrases.learn_more"}}
            />
          </p>
        </div>
      </div>
    </div>
  </section>
  */
  {
    "id": "fgjZHJ4Y",
    "block": "[[[10,\"section\"],[14,0,\"o--modalBody--secondary u--p__0 has--footer\"],[12],[1,\"\\n\"],[1,\"  \"],[10,0],[14,0,\"cMH--blank\"],[12],[1,\"\\n    \"],[8,[39,0],null,null,null],[1,\"\\n    \"],[10,0],[14,0,\"cMH--blank__overlay is--centered\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"u--p\"],[12],[1,\"\\n        \"],[10,2],[14,0,\"u--text--bold u--text--md u--text--center u--m__b__xs\"],[12],[1,\"\\n          \"],[1,[30,1]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,2],[14,0,\"u--text--light u--text--center u--m__b__0\"],[12],[1,\"\\n          \"],[1,[30,2]],[1,\"\\n          \"],[8,[39,1],[[16,\"title\",[28,[37,2],[\"hashtag_suggestions.upsell.title\"],null]]],[[\"@href\",\"@text\"],[[30,3],[28,[37,2],[\"shared_phrases.learn_more\"],null]]],null],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@upgradeTitle\",\"@upgradeDescription\",\"@href\"],false,[\"shared/post/secondary/hashtag-suggestions/upgrade-modal-background\",\"shared/link\",\"t\"]]",
    "moduleName": "shared/components/shared/post/secondary/hashtag-suggestions/paid-upgrade-modal.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});